import OtpInput from "react18-input-otp";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./style.css";

const OtpField = ({ value, onChange, onSubmit, hasErrored }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Backspace") {
        onChange("");
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onChange]);

  const handleInputChange = (newValue) => {
    const numericValue = newValue.replace(/\D/g, "");
    onChange(numericValue);
  };

  return (
    <OtpInput
      focusStyle={{
        border: "1px solid #C3C5C7",
        borderRadius: "5px",
      }}
      inputStyle={{
        border: "1px solid #C3C5C7",
        borderRadius: "5px",
        width: "45px",
        height: "50px",
        fontSize: "25px",
        marginRight: "10px",
      }}
      errorStyle={{
        border: "1px solid #D32F2F",
      }}
      value={value}
      onChange={handleInputChange}
      numInputs={6}
      shouldAutoFocus={true}
      isInputNum={true}
      separator={<span>{""}</span>}
      onSubmit={onSubmit}
      hasErrored={hasErrored}
    />
  );
};

OtpField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  hasErrored: PropTypes.bool,
};

export default OtpField;
